var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useCheckIsEnterprise, useCurrentMemberByWorkspaceId, } from '#query-hooks';
import { canManageAccessAndPermissions, canUpgradeFilespace, isAbleToUnlockUpgrade, } from '#services';
export const useFilespaceCapabilities = ({ filespace, workspaceId, }) => {
    _react_refresh_temp_1();
    const { query: { data: currentMemberData }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { isEnterprise, isError: isErrorEnterprise, isPending: isPendingEnterprise, } = useCheckIsEnterprise(workspaceId);
    const canUpgrade = useMemo(() => {
        if (!filespace ||
            !currentMemberData ||
            isPendingEnterprise ||
            isErrorEnterprise) {
            return false;
        }
        return canUpgradeFilespace({
            filespace,
            currentMember: currentMemberData,
            isEnterprise,
        });
    }, [
        filespace,
        currentMemberData,
        isEnterprise,
        isPendingEnterprise,
        isErrorEnterprise,
    ]);
    const isAbleToUnlock = useMemo(() => {
        if (!filespace ||
            !currentMemberData ||
            isPendingEnterprise ||
            isErrorEnterprise) {
            return false;
        }
        return isAbleToUnlockUpgrade({
            filespace,
            currentMember: currentMemberData,
            isEnterprise,
        });
    }, [
        filespace,
        currentMemberData,
        isEnterprise,
        isPendingEnterprise,
        isErrorEnterprise,
    ]);
    const canManageAccess = canManageAccessAndPermissions({
        currentMemberData,
        filespaceId: filespace?.id,
    });
    return {
        data: {
            canUpgrade,
            isAbleToUnlock,
            canManageAccess,
        },
        isPending: isPendingEnterprise,
        isError: isErrorEnterprise,
    };
};
_react_refresh_temp_1(useFilespaceCapabilities, "Jvc0wcpAbyJTEPbD+wmkTTDAP8w=", false, () => [useCurrentMemberByWorkspaceId, useCheckIsEnterprise]);
